var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-component"},[_c('common-card',{attrs:{"items":_vm.refineItems,"is-tag":true,"is-badge":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }